// initialState
const initialState = {
    reservations: [],
    forms: [],
    formNumber: 0,
    showMessage: false
}

// types
const CREATE_RESERVATIONS = 'CREATE_RESERVATIONS',
      SAVE_RESERVATION_DATA = 'SAVE_RESERVATION_DATA',
      NUMBER_OF_FORM = 'NUMBER_OF_FORM',
      EDIT_RESERVATION_DATA = 'EDIT_RESERVATION_DATA',
      SHOW_MESSAGE = 'SHOW_MESSAGE';

// reducers
const multiBookingReducer = (state=initialState, action) => {
    switch(action.type){
        case 'CREATE_RESERVATIONS': return{
            ...state,
            reservations: action.payload
        }
        case 'SAVE_RESERVATION_DATA': return{
            ...state,
            forms: [...state.forms, action.payload]
        }
        case 'NUMBER_OF_FORM': return{
            ...state,
            formNumber: action.payload
        }
        case 'EDIT_RESERVATION_DATA': return{
            ...state,
            forms: action.payload
        }
        case 'SHOW_MESSAGE': return{
            ...state,
            showMessage: action.payload
        }
        default: return state;
    }
}

// actions
const multiBookingAction = (reservations) => async (dispatch, getState) => {
    dispatch({
        type: CREATE_RESERVATIONS,
        payload: reservations
    });
}

const saveReservationsAction = (formNumber, data) => async (dispatch, getState) => {

    dispatch({
        type: NUMBER_OF_FORM,
        payload: formNumber
    });

    dispatch({
        type: SAVE_RESERVATION_DATA,
        payload: data
    });
}

const editFormActions = (formNumber, formData) => async (dispatch, getState) => {

    const newFormsData = getState().MultiBooking.forms;

    newFormsData[formNumber] = formData;

    dispatch({
        type: EDIT_RESERVATION_DATA,
        payload: newFormsData
    });
}

const prevoiusFormAction = (formNumber) => async (dispatch, getState) => {
    dispatch({
        type: NUMBER_OF_FORM,
        payload: formNumber
    });
}

const showMessageAction = () => async (dispatch, getState) => {

    const messageState = getState().MultiBooking.showMessage;

    dispatch({
        type: SHOW_MESSAGE,
        payload: !messageState
    });
}


// exports
export { multiBookingAction, saveReservationsAction, editFormActions, prevoiusFormAction, showMessageAction }

export default multiBookingReducer;